<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
	<footer
		class="the-footer flex-wrap justify-between"
		:class="classes"
	>
		<span>COPYRIGHT &copy; {{ new Date().getFullYear() }} <a
				href="https://pannonhome.hu"
				target="_blank"
				rel="nofollow"
			>Pannonhome</a>, All rights Reserved</span>
		<span class="md:flex hidden items-center">
			<span>Hibabejelentés: andras.schulcz@gmail.com</span>
		</span>
	</footer>
</template>

<script>
export default {
	name: "the-footer",
	props: {
		classes: {
			type: String,
		},
	}
}
</script>
